var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _class2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { attr } from '@ember-data/model';
import { array } from 'ember-data-model-fragments/attributes';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogCustomAttributeDefinition } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/datatypes';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { inject as service } from '@ember/service';
const NUMBER_VALUE_DENOMINATOR = 100000;
const STRING_MAX_LENGTH = 255;
const MAXIMUM_PRECISION = Math.log10(NUMBER_VALUE_DENOMINATOR);
var CustomAttributeType = /*#__PURE__*/function (CustomAttributeType) {
  CustomAttributeType["STRING"] = "STRING";
  CustomAttributeType["INTEGER"] = "INTEGER";
  CustomAttributeType["BOOLEAN"] = "BOOLEAN";
  CustomAttributeType["NUMBER"] = "NUMBER";
  CustomAttributeType["SELECTION"] = "SELECTION";
  CustomAttributeType["STRING_INT"] = "STRING_INT";
  CustomAttributeType["TOKEN_INT"] = "TOKEN_INT";
  return CustomAttributeType;
}(CustomAttributeType || {});
let CustomAttributeValue = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('number'), _dec5 = attr('string'), _dec6 = attr('boolean'), _dec7 = array(), _dec8 = attr('string', {
  enumClass: CustomAttributeType,
  protoEnum: CatalogCustomAttributeDefinition.Type
}), _dec9 = attr('string'), _dec10 = alias('customAttributeDefinitionId'), _dec11 = computed('customAttributeDefinitionId', 'store'), (_class = (_class2 = class CustomAttributeValue extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "customAttributeDefinitionId", _descriptor, this);
    _initializerDefineProperty(this, "name", _descriptor2, this);
    _initializerDefineProperty(this, "stringValue", _descriptor3, this);
    _initializerDefineProperty(this, "intValue", _descriptor4, this);
    _initializerDefineProperty(this, "numberValue", _descriptor5, this);
    _initializerDefineProperty(this, "booleanValue", _descriptor6, this);
    _initializerDefineProperty(this, "selectionUidValues", _descriptor7, this);
    _initializerDefineProperty(this, "store", _descriptor8, this);
    _initializerDefineProperty(this, "type", _descriptor9, this);
    _initializerDefineProperty(this, "key", _descriptor10, this);
    _initializerDefineProperty(this, "definitionToken", _descriptor11, this);
  }
  // Used to easily determine if an arbitrary custom attribute value has changed
  get stringifiedValue() {
    const {
      booleanValue,
      intValue,
      numberValue,
      selectionUidValues,
      stringValue
    } = this;
    return (booleanValue ?? intValue ?? numberValue ?? stringValue ?? selectionUidValues?.toArray().join(','))?.toString();
  }

  /*
    `customAttributeDefinitionId` contains the id of a `connect/custom-attribute-definition` model. This computed
    property can be used in place of a real EmberData relationship because for now fragments do not support relationships.
  */
  get customAttributeDefinition() {
    return this.customAttributeDefinitionId ? this.store.peekRecord('connect/custom-attribute-definition', this.customAttributeDefinitionId) : null;
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/custom-attribute-value'), _defineProperty(_class2, "NUMBER_VALUE_DENOMINATOR", NUMBER_VALUE_DENOMINATOR), _defineProperty(_class2, "STRING_MAX_LENGTH", STRING_MAX_LENGTH), _defineProperty(_class2, "MAXIMUM_PRECISION", MAXIMUM_PRECISION), _defineProperty(_class2, "CustomAttributeType", CustomAttributeType), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "customAttributeDefinitionId", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "stringValue", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intValue", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "numberValue", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "booleanValue", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectionUidValues", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "type", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "key", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "definitionToken", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "customAttributeDefinition", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "customAttributeDefinition"), _class.prototype)), _class));
export { CustomAttributeValue as default };